/* istanbul ignore file */
import { useShowContext } from 'framework/show';
import VacancyLinkField from 'domain/recruiting/vacancy/shared/input/VacancyLinkField';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { CANDIDATE_TIMELINE_ICONS, CANDIDATE_TIMELINE_MESSAGE_CONTEXT } from 'domain/shared/candidate';

const ApplicationTimelineRecordLayout = (props: any) => {
  const { data } = useShowContext();

  return (
    <BasePersonTimelineRecordLayout
      timelineIcons={CANDIDATE_TIMELINE_ICONS}
      messageContext={CANDIDATE_TIMELINE_MESSAGE_CONTEXT}
      fields={
        <>
          <VacancyLinkField source="vacancyAlias" label="Application for vacancy has been created" />
        </>
      }
      entity={data}
      timelineType="Application"
      buttons={[]}
      actions={[]}
      timelineFooter={() => null}
      {...props}
    />
  );
};

export default ApplicationTimelineRecordLayout;
